
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const state = {
    Authorization: localStorage.getItem("Authorization_lineSupplier") ? JSON.parse(localStorage.getItem("Authorization_lineSupplier")) :null
}

const mutations = {
    addUserdata(state, data) {
        state.Authorization = data
    }

}
export default new Vuex.Store({
    state,
    mutations
});



// WEBPACK FOOTER //
// ./src/store/index.js